function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { TwoItemSwiper } from "../../TwoItemSwiper/TwoItemSwiper";
import { ToutSlice } from "../ToutSlice/ToutSlice";
import styles from "./ToutWithSwiperSlice.module.scss";
import { Button } from "../../Button/Button/Button";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ToutWithSwiperSlice = function ToutWithSwiperSlice(_ref) {
  var _toutProps$tout, _toutProps$tout2, _toutProps$tout2$butt;
  var _ref$swiperProps = _ref.swiperProps,
    swiperProps = _ref$swiperProps === void 0 ? [] : _ref$swiperProps,
    _ref$toutProps = _ref.toutProps,
    toutProps = _ref$toutProps === void 0 ? {
      background: {},
      tout: {}
    } : _ref$toutProps;
  var buildFirstSwiperItem = function buildFirstSwiperItem(item) {
    return /*#__PURE__*/_jsxs("div", {
      className: styles.firstPart,
      style: {
        height: item !== null && item !== void 0 && item.firstPartHeight ? "".concat(item.firstPartHeight, "px") : ''
      },
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.headerText,
        children: item === null || item === void 0 ? void 0 : item.headerText
      }), /*#__PURE__*/_jsx("div", {
        className: styles.subHeaderText,
        children: item === null || item === void 0 ? void 0 : item.subHeaderText
      })]
    });
  };
  var buildSecondSwiperItem = function buildSecondSwiperItem(img) {
    return /*#__PURE__*/_jsx("div", {
      className: styles.secondPart,
      style: {
        backgroundImage: img ? "url('".concat(img, "')") : ''
      }
    });
  };
  var swiperInnerProps = swiperProps === null || swiperProps === void 0 ? void 0 : swiperProps.map(function (item) {
    return {
      FirstItem: buildFirstSwiperItem(item),
      SecondItem: buildSecondSwiperItem(item === null || item === void 0 ? void 0 : item.img)
    };
  });
  return /*#__PURE__*/_jsxs("div", {
    className: styles.toutWithSwiperSlice,
    children: [toutProps && /*#__PURE__*/_jsx("div", {
      className: styles.columnOne,
      children: /*#__PURE__*/_jsx(ToutSlice, _objectSpread({
        boundaryClassName: styles.boundary
      }, toutProps))
    }), /*#__PURE__*/_jsx("div", {
      className: styles.columnTwo,
      children: /*#__PURE__*/_jsx(TwoItemSwiper, {
        items: swiperInnerProps
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.buttonWrapper,
      children: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, toutProps === null || toutProps === void 0 ? void 0 : (_toutProps$tout = toutProps.tout) === null || _toutProps$tout === void 0 ? void 0 : _toutProps$tout.button), {}, {
        children: toutProps === null || toutProps === void 0 ? void 0 : (_toutProps$tout2 = toutProps.tout) === null || _toutProps$tout2 === void 0 ? void 0 : (_toutProps$tout2$butt = _toutProps$tout2.button) === null || _toutProps$tout2$butt === void 0 ? void 0 : _toutProps$tout2$butt.text
      }))
    })]
  });
};